import React from "react";
import { useNavigate } from "react-router-dom";
import HomeIcon from "../assets/icons/thinkIcons/Home.png";
import FraudImage from "../assets/img/fraud_detection.png";
import SpecTransaction from "../assets/icons/thinkIcons/SpecTransaction.png";
import MulTransaction from "../assets/icons/thinkIcons/MulTransaction.png";

const FraudDetectionSystem = () => {
  const navigate = useNavigate();

  const handleHomeClick = () => {
    navigate("/user/dashboard");
  };

  const handleSpecificTransactionClick = () => {
    navigate("/user/dashboard/fraud_detection/specific_transaction");
  };

  const handleMultipleTransactionClick = () => {
    navigate("/user/dashboard/fraud_detection/multiple_transaction");
  };

  return (
    <div className="p-4 sm:p-6 md:p-8 lg:p-10">
      <div>
        {/* Header Row */}
        <div className="flex justify-end">
          <button
            className="flex items-center gap-2 border px-3 py-2 rounded-full cursor-pointer"
            onClick={handleHomeClick}
          >
            <img src={HomeIcon} className="w-4 h-4 sm:w-[18px] sm:h-[18px]" />
            <span className="text-xs sm:text-sm">Home</span>
          </button>
        </div>

        {/* Top Card */}
        <div className="border-1 rounded-md mt-4 flex flex-col sm:flex-row p-3 gap-4 border-blue-custom">
          <img
            src={FraudImage}
            alt="Advisory Tool"
            className="w-full sm:w-[200px] h-[160px] sm:h-[120px] object-cover rounded-md"
          />
          <div>
            <h2 className="textcolor font-semibold text-lg sm:text-xl">
              Fraud Detection System
            </h2>
            <p className="textsec text-sm sm:text-base">
              Smart fraud checks for single or bulk financial data.
            </p>
          </div>
        </div>

        {/* Description */}
        <div className="mt-4 text-base sm:text-xl textdark font-semibold leading-relaxed">
          <p>
            The fraud detection system is an automated ML system which helps to
            classify whether a transaction is a fraud transaction or not and
            also represent it graphically.
          </p>
        </div>

        {/* Features box */}
        <div className="mt-4 border-1 border-blue-custom rounded-md p-4">
          <h6 className="text-base sm:text-xl font-semibold textcolor mb-3">
            Features:
          </h6>
          <ol className="list-decimal pl-5 textdark text-sm sm:text-lg space-y-4">
            <li>
              Fraud prediction: Users get whether a specific transaction is
              fraudulent or not fraudulent based on the transaction input.
            </li>
            <li>
              CSV file upload for multiple transactions: User can upload csv
              file of multiple transactions and get number of fraudulent and not
              fraudulent transactions.
            </li>
            <li>
              Graphical representation: Users can get stacked bar graph for
              fraudulent and not fraudulent number of transactions based on the
              transactions of csv file uploaded.
            </li>
          </ol>
        </div>

        {/* Feature Buttons */}
        <div className="w-full max-w-5xl mx-auto mt-10 sm:mt-16 flex flex-col md:flex-row justify-center gap-6 sm:gap-12">
          {/* Specific Transactions */}
          <div
            onClick={handleSpecificTransactionClick}
            className="border-1 border-blue-custom rounded-md p-1 sm:p-1 flex flex-col sm:flex-row items-center sm:justify-evenly   w-full md:w-1/2 bg-[#0D568E1A] cursor-pointer hover:shadow-lg transition"
          >
            <img
              src={SpecTransaction}
              alt="Specific Transaction"
              className="w-[100px] sm:w-[121px] h-[100px] sm:h-[121px]"
            />
            <p className="text-lg sm:text-2xl font-semibold textdark text-center sm:text-left w-50">
              Check for Specific Transactions
            </p>
          </div>

          {/* Multiple Transactions */}
          <div
            onClick={handleMultipleTransactionClick}
            className="border-1 border-blue-custom rounded-md p-1 sm:p-1 flex flex-col sm:flex-row items-center sm:justify-evenly   w-full md:w-1/2 cursor-pointer hover:shadow-lg transition"
          >
            <img
              src={MulTransaction}
              alt="Multiple Transactions"
              className="w-[85px] sm:w-[93px] h-[95px] sm:h-[105px]"
            />
            <p className="text-lg sm:text-2xl font-semibold textdark text-center sm:text-left w-50">
              Check for Multiple Transactions
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FraudDetectionSystem;
